// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"FakeRow_loaderWrapper__1gydy","errorMsg":"FakeRow_errorMsg__1rWxH"};